/* eslint-disable camelcase */
module.exports = {
	methods: {
		users() {
			const self = this;

			return {
				async get(id) {
					try {
						const response = await self.$http.get(
							`users/${id}`, {
								params: {},
								headers: {
									Authorization: false,
								},
							},
						);

						const deals = {
							total: response.data.deals.total,
							results: self.helpers().formatDeals(response.data.deals.results),
						};

						return {
							ok: true,
							data: {
								deals,
								user: response.data.user,
							},
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
						};
					}
				},
				async add({ username, email, password, newsletter = false }) {
					try {
						const response = await self.$http.post('auth/addNewUser', {
							username,
							email,
							password,
							newsletter,
						}, {
							headers: {
								Authorization: false,
							},
						});

						self.resetStatus();

						return response.data;
					} catch (error) {
						self.resetStatus();

						return {
							ok: false,
							data: null,
							error: null,
						};
					}
				},
				async deals({ user_id, offset = 0, limit = self.limit, order_by = null }) {
					try {
						const response = await self.$http.get(
							`users/${user_id}/deals`, {
								params: {
									offset,
									limit,
									order_by,
								},
								headers: {
									Authorization: false,
								},
							},
						);

						const deals = {
							total: response.data.deals.total,
							results: self.helpers().formatDeals(response.data.deals.results),
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async comments({ userId, offset = 0, limit = self.limit }) {
					try {
						const response = await self.$http.get(
							`users/${userId}/comments`, {
								params: {
									offset,
									limit,
								},
								headers: {
									Authorization: false,
								},
							},
						);

						const deals = {
							total: response.data.comments.total,
							results: response.data.comments.results,
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async likedDeals({ userId, offset = 0, limit = self.limit }) {
					try {
						const response = await self.$http.get(
							`users/${userId}/liked_deals`, {
								params: {
									offset,
									limit,
								},
								headers: {
									Authorization: false,
								},
							},
						);

						const deals = {
							total: response.data.liked_deals.total,
							results: self.helpers().formatDeals(response.data.liked_deals.results),
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async likedComments({ userId, offset = 0, limit = self.limit }) {
					try {
						const response = await self.$http.get(
							`users/${userId}/liked_comments`, {
								params: {
									offset,
									limit,
								},
								headers: {
									Authorization: false,
								},
							},
						);

						const deals = {
							total: response.data.liked_comments.total,
							results: response.data.liked_comments.results,
						};

						return {
							ok: true,
							data: deals,
							error: null,
						};
					} catch (error) {
						return {
							ok: false,
							data: [],
							error: null,
						};
					}
				},
				async avatar(formData) {
					try {
						const response = await self.$http.post(
							'app/api/avatar', formData, {
								headers: {
									Authorization: true,
									baseType: 'cdn',
								},
							},
						);

						self.resetStatus();

						return {
							ok: true,
							image_url: response.data.image_url,
						};
					} catch (error) {
						self.resetStatus();

						return {
							ok: false,
							image_url: null,
						};
					}
				},
				async changePassword(userId, oldPassword, newPassword) {
					try {
						await self.$http.patch(`users/${userId}`, {
							current_password: oldPassword,
							new_password: newPassword,
						}, {
							headers: {
								Authorization: true,
							},
						});

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async delete({ userId, password }) {
					try {
						self.loader = 'Eliminando tu cuenta...';

						const result = await self.$http.delete(
							`users/${userId}`, {
								headers: {
									Authorization: true,
								},
								data: {
									current_password: password,
								},
							},
						);
						self.resetStatus();

						if (result) return true;
						return false;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
				async forgotPassword(username) {
					try {
						self.loader = 'Solicitando reemplazo de credenciales';

						await self.$http.get(
							`auth/forgotPassword/${username}`, {
								headers: {
									Authorization: false,
								},
							},
						);

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();

						return false;
					}
				},
				async edit({ userId, bio = undefined, imageUrl = undefined, currentPassword = undefined, newPassword = undefined, username = undefined, role = undefined, email = undefined }) {
					try {
						await self.$http.patch(`users/${userId}`, {
							current_password: currentPassword,
							new_password: newPassword,
							image_url: imageUrl,
							bio,
							username,
							role,
							email,
						}, {
							headers: {
								Authorization: true,
							},
						});

						self.resetStatus();

						return true;
					} catch (error) {
						self.resetStatus();
						return false;
					}
				},
			};
		},
	},
};
